import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { isFormattedNumber } from '@atheneum/api/dist/lib'
import Tooltip from '@components/Tooltip'
import Star from '@components/Icon/Star'

const Badge = ({ label, value, tooltip, onClick, hasStar, starClasses, decoration }) => {
  const colors = [
    '#F6A623', // 0 gray
    '#a91f24', // 1 gray
    '#a81c25', // 2 gray
    '#c11b24', // 3 gray
    '#d51f24', // 4 gray
    '#e5312a', // 5 gray
    '#e74f17', // 6 gray
    '#f29200', // 7 gray
    '#f9b131', // 8 gray
    '#97c022', // 9 gray
    '#3aaa34' // 10 gray
  ]

  const classes = classNames({
    floating: true,
    clickable: !!onClick
  })
  const isNumericVal = typeof value === 'number' || isFormattedNumber(value)
  const badgeValue = value && isNumericVal ? value : 'N/A'
  const content = (
    <div>
      <h1 className={hasStar ? 'flex-center' : decoration || ''}>
        {hasStar && (
          <Star fill={starClasses} fillColor={colors[Math.floor(value) ?? 0]} />
        )}
        {badgeValue}
      </h1>
      <span>{label}</span>
    </div>
  )

  return (
    <div className={classes} onClick={onClick}>
      {tooltip ? (
        <Tooltip tooltip={tooltip} placement='bottom'>
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </div>
  )
}

Badge.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  hasStar: PropTypes.bool,
  starClasses: PropTypes.string
}

export default observer(Badge)
